(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faceted-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-magpie-type-aliases]');
    if (!link) return;
    const aliases = link.dataset.magpieTypeAliases.split('~');
    const url = new URL(window.location.href);
    const remaining = url.searchParams.getAll('filter.p.product_type')
      .flatMap((value) => value.split(','))
      .filter((value) => !aliases.includes(value.trim().toLowerCase()));
    url.searchParams.delete('filter.p.product_type');
    remaining.forEach((value) => url.searchParams.append('filter.p.product_type', value));
    link.href = url.toString();
  }, true);
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input.matches('#CollectionFilterForm input[name="filter.p.product_type"]') && !input.hasAttribute('data-magpie-type-alias')) {
      input.closest('label')?.querySelectorAll('[data-magpie-type-alias]').forEach((alias) => { alias.checked = input.checked; });
    }
    if (!input.matches('#CollectionFilterForm input[name="filter.v.option.size"], #CollectionFilterForm input[name="filter.v.option.sizes"]') || !input.checked) return;
    const availability = input.form?.querySelector('input[name="filter.v.availability"][value="1"]');
    if (availability) availability.checked = true;
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magpie-collection-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const button=event.target.closest('[data-carousel-direction]');
  if(!button)return;
  const track=document.getElementById(button.getAttribute('aria-controls'));
  if(!track)return;
  const card=track.querySelector('.mcc__card');
  if(!card)return;
  const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
  const count=Math.max(1,Math.floor(track.clientWidth/step));
  track.scrollBy({left:Number(button.dataset.carouselDirection)*step*count,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magpie-landing-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const button=event.target.closest('[data-weekly-direction]');
  if(!button)return;
  const track=button.closest('.magpie-landing-products').querySelector('#MagpieWeeklyProducts');
  track.scrollBy({left:Number(button.dataset.weeklyDirection)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magpie-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const summary=event.target.closest('.magpie-nav--structured > li > details > summary');if(!summary)return;const current=summary.parentElement;const nav=current.closest('.magpie-nav--structured');nav.querySelectorAll(':scope > li > details[open]').forEach(item=>{if(item!==current)item.open=false;});});

document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;const nav=event.target.closest('.magpie-nav--structured');if(!nav)return;const details=event.target.closest('details[open]');if(details){details.open=false;details.querySelector('summary').focus();event.stopPropagation();}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('on:cart:add', (event) => {
  const form = event.target.closest('product-form[data-magpie-quiet-add]');
  if (!form || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const button = form.querySelector('.magpie-grid-add');
  const cart = document.querySelector('.cart-link');
  const card = form.closest('product-block, .xmas-pick');
  const photo = card?.querySelector('.product-block__image--active img, .xmas-pick__image img');
  if (!button || !cart || !photo) return;
  const start = button.getBoundingClientRect();
  const end = cart.getBoundingClientRect();
  if (!end.width || end.bottom < 0 || end.top > window.innerHeight) return;
  const token = document.createElement('img');
  token.src = photo.currentSrc || photo.src;
  token.alt = '';
  token.setAttribute('aria-hidden', 'true');
  Object.assign(token.style, {
    position: 'fixed', left: `${start.left + start.width / 2 - 19}px`,
    top: `${start.top + start.height / 2 - 24}px`, width: '38px', height: '48px',
    objectFit: 'cover', border: '2px solid white', borderRadius: '7px',
    boxShadow: '0 3px 10px rgb(0 0 0 / .12)', pointerEvents: 'none', zIndex: '10000'
  });
  document.body.appendChild(token);
  const dx = end.left + end.width / 2 - (start.left + start.width / 2);
  const dy = end.top + end.height / 2 - (start.top + start.height / 2);
  const flight = token.animate([
    { transform: 'translate(0,0) scale(.7) rotate(-8deg)', opacity: 0 },
    { transform: 'translate(0,-25px) scale(1.15) rotate(5deg)', opacity: 1, offset: .18 },
    { transform: `translate(${dx * .55}px,${dy * .55 - 65}px) scale(.85) rotate(-10deg)`, opacity: 1, offset: .62 },
    { transform: `translate(${dx}px,${dy}px) scale(.15) rotate(0)`, opacity: 0 }
  ], { duration: 850, easing: 'cubic-bezier(.22,.61,.36,1)' });
  flight.finished.then(() => {
    token.remove();
    cart.animate([
      { transform: 'scale(1)' }, { transform: 'scale(1.2) rotate(-5deg)', offset: .4 },
      { transform: 'scale(.95) rotate(3deg)', offset: .72 }, { transform: 'scale(1)' }
    ], { duration: 360, easing: 'ease-out' });
  }).catch(() => token.remove());
});
  } catch(e) { console.error(e); }
})();

})();
